import React from "react";
import Heading from "./Heading";
import "../scss/portfolios.scss";
import Portfolio from "../components/Portfolio";
import projects from "../assets/projects/projectsList.json";

const Portfolios = () => {
  return (
    <section id="portfolio" className="portfolios">
      <Heading id="portfolioHeading" number="03" text="Portfolio" />
      {projects.map((project) => {
        return <Portfolio key={project.title} project={project} />;
      })}
    </section>
  );
};

export default Portfolios;
